export const CONTENT_TYPE_PRODUCT_INFO = 'product-info'; // model.xml name



// WEBPACK FOOTER //
// ./collection-institutional-portal/prebuilt/content-types/product-info-type/constant.js